export default {
    juba: {
        header: {
            name: 'Juba Restaurant',
            title: 'Juba Restaurant',

        },

        menu: [
 
            {
                id: 2,
                label: "Menu",
                url: "",
                subpages: [
                    {
                        label: 'breakfast',
                        url: '/breakfast'
                    },
                    {
                        label: 'Launch',
                        url: '/launch'
                    },
                    {
                        label: 'Dinner',   
                        url: '/dinner'
                    },
                    {
                        label: 'Full Menu',   
                        url: '/fullMenu'
                    }

                ]
            },


            {
                id: 1,
                label: "About",
                url: "",   //should be the about page
                subpages: [
                    {
                        label: 'Our Name',
                        url: '/ourName'
                    },
                    {
                        label: 'Our Vision & Mission ',
                        url: '/ourVision'
                    },

                    {
                        label: 'Contact Us',
                        url: '/contactUs'
                    }
                ]   
            },
       
    
        ],

        launch: [
                {
                    id:1,
                    title: 'Place holder for meal name',
                    price: '$11.50',
                    image: "/assets/launch101.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah',
                    colories: '600 col',
                    ingredients: '',
                },
                {
                    id:2,
                    title: 'Place holder for meal name',
                    price: '$12.50',
                    image: "/assets/launch102.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah',
                    colories: '600 col',
                    ingredients: '',
                },
                {
                    id:3,
                    title: 'Place holder for meal name',
                    price: '$18.50',
                    image: "/assets/launch103.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah',
                    colories: '600 col',
                    ingredients: '',
                },
                {
                    id:4,
                    title: 'Place holder for meal name',
                    price: '$122.50',
                    image: "/assets/launch104.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                    colories: '600 col',
                    ingredients: '',
                }, 
                {
                    id:5,
                    title: 'Place holder for meal name',
                    price: '$18.63',
                    image: "/assets/launch105.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                    colories: '600 col',
                    ingredients: '',
                },
                {
                    id:6,
                    title: 'Place holder for meal name',
                    price: '$122.50',
                    image: "/assets/launch106.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                    colories: '600 col',
                    ingredients: '',
                },
                
                {
                    id:7,
                    title: 'Place holder for meal name',
                    price: '$122.50',
                    image: "/assets/launch107.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                    colories: '600 col',
                    ingredients: '',
                }, 

                {
                    id:8,
                    title: 'Place holder for meal name',
                    price: '$122.50',
                    image: "/assets/launch108.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                    colories: '600 col',
                    ingredients: '',
                },
                
                {
                    id:9,
                    title: 'Place holder for meal name',
                    price: '$122.50',
                    image: "/assets/launch109.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                    colories: '600 col',
                    ingredients: '',
                }, 
                {
                    id:10,
                    title: 'Place holder for meal name',
                    price: '$122.50',
                    image: "/assets/launch110.jpg",
                    description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                    colories: '600 col',
                    ingredients: '',
                }, 
            ],
        dinner: [
            {
                id:1,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner102.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            }, 

            {
                id:2,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner103.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            }, 

            {
                id:3,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner104.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            }, 

            {
                id:4,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner105.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            }, 

            {
                id:5,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner106.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            }, 

            {
                id:6,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner107.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            }, 

            {
                id:7,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner108.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            }, 

            {
                id:8,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner109.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:9,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner110.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            
            {
                id:10,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner111.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
                
        ],
        breakfast: [
            {
                id:1,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning101.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:2,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning102.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:3,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning103.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:4,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning104.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:5,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning105.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:6,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning106.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:7,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning107.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:8,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning108.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:9,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning109.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:10,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning110.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:11,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning111.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },

        ],
        favorites: [
            {
                id:1,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/launch103.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:2,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/launch106.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:3,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/launch107.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:4,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner102.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:5,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner104.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:6,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/dinner106.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:7,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/mid102.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:8,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning107.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:9,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning110.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },
            {
                id:10,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/morning103.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },

            {
                id:12,
                title: 'Place holder for meal name',
                price: '$122.50',
                image: "/assets/mid102.jpg",
                description: 'Hilib ari si fiican loo sheelay iyo bariis kaaly iska arag ah qofkii cunaa waa la mashquuli',
                colories: '600 col',
                ingredients: '',
            },

        ],

        footer: {
            subheading: 'Get connected with us on social media!',
            name: 'SPSHub',
            links: [
            {
                id: 0,
                name: 'Facebook',
                link: 'facebook-link',
                icon: 'fab fa-facebook'
            },
            {
                id: 1,
                name: 'Twitter',
                link: 'twitter-link',
                icon: 'fab fa-twitter'
            },
            {
                id: 2,
                name: 'Instagram',
                link: 'instagram-link',
                icon: 'fab fa-instagram'
            },
            {
                id: 3,
                name: 'YouTube',
                link: 'youtube-link',
                icon: 'fab fa-youtube'
            }
            ]
        }
    }
};